// extracted by mini-css-extract-plugin
export default {"profileFormWrapper":"ProfileForm_profileFormWrapper__LH3Xo"};